// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3SQVY","resendInfoText":"OnGoingPaymentBox_resendInfoText__1pbDv"};